import {
  GridPreferencePanelsValue,
  gridPreferencePanelStateSelector,
  useGridApiContext,
  useGridRootProps,
  useGridSelector,
} from '@mui/x-data-grid-premium'
import { PointerEvent, useId } from 'react'

export const useFilterPanelToggle = () => {
  const apiRef = useGridApiContext()
  const { disableColumnFilter } = useGridRootProps()
  const preferencePanel = useGridSelector(apiRef, gridPreferencePanelStateSelector)
  const isFilterPanelOpen = preferencePanel.open && preferencePanel.openedPanelValue === GridPreferencePanelsValue.filters
  const buttonId = useId()
  const panelId = useId()

  const toggleFilterPanel = () =>
    isFilterPanelOpen ? apiRef.current.hidePreferences() : apiRef.current.showFilterPanel(undefined, panelId, buttonId)

  // The open panel closes itself on any click outside it, so without this a click on the button would close it and
  // then reopen it.
  const keepOpenPanelFromClosingItself = (event: PointerEvent) => {
    if (preferencePanel.open) event.stopPropagation()
  }

  return {
    isFilterButtonShown: !disableColumnFilter,
    filterButtonProps: {
      id: buttonId,
      'aria-controls': isFilterPanelOpen && preferencePanel.panelId === panelId ? panelId : undefined,
      'aria-haspopup': true,
      'aria-expanded': isFilterPanelOpen,
      onClick: toggleFilterPanel,
      onPointerUp: keepOpenPanelFromClosingItself,
    },
  }
}
